import RecommendationsSection from './RecommendationsSection';
import { getRecommendationsMetadataList
//@ts-expect-error Could not find declaration file for module
} from '../../selectors/recommendationsSelectors';
import { useSelector } from 'react-redux';
import FormattedMessage from 'I18n/components/FormattedMessage';
import FormattedReactMessage from 'I18n/components/FormattedReactMessage';
import { useMemo, useState } from 'react';
import UsageTracker from '../../utils/UsageTracker';
import { isLessonRecommendation } from '../../features/recommendations/recommendationsUtils';
import { useHistory } from 'react-router-dom';
import { LikeLink, RouterLink } from '../AcademyLinks';
import { EERIE } from 'HubStyleTokens/colors';
import { WIZARD_URL_FRAGMENT } from '../../constants/Navigation';
import UIIconButton from 'UIComponents/button/UIIconButton';
import UIIcon from 'UIComponents/icon/UIIcon';
import RecommendationsResetModal from './RecommendationsResetModal';
import { useRecommendations } from '../../features/recommendations';
import styled from 'academy-common-lib/utils/Styling';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const Bold = styled.span.withConfig({
  displayName: "RecommendationsBasedOnProgress__Bold",
  componentId: "sc-78zflu-0"
})(["font-weight:400;"]);
const SubTitleTopMessage = ({
  showIndividualReasons,
  metadataList
}) => {
  if (showIndividualReasons) return /*#__PURE__*/_jsx(FormattedMessage, {
    message: "learningCenter.tracks.subheaders.personalRecommendations"
  });
  if (metadataList.length) {
    return /*#__PURE__*/_jsx(FormattedReactMessage, {
      message: "learningCenter.tracks.subheaders.becauseYouInteractedWithOne",
      options: {
        contentNames: metadataList[0].contentName
      }
    });
  }
  return null;
};
const SubTitle = ({
  showIndividualReasons,
  metadataList,
  onInfoButtonClick
}) => {
  const handleResetLinkClick = () => {
    UsageTracker.track('interaction', {
      action: 'catalog-recommendation-reset-click'
    });
  };
  const handleResetInfoClick = () => {
    UsageTracker.track('interaction', {
      action: 'catalog-recommendation-reset-info-click'
    });
    onInfoButtonClick();
  };
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsx(SubTitleTopMessage, {
      metadataList: metadataList,
      showIndividualReasons: showIndividualReasons
    }), /*#__PURE__*/_jsx(RouterLink, {
      className: "m-left-1",
      onClick: handleResetLinkClick,
      to: WIZARD_URL_FRAGMENT,
      children: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "learningCenter.tracks.resetLink.linkMessage"
      })
    }), /*#__PURE__*/_jsx(UIIconButton, {
      onClick: handleResetInfoClick,
      style: {
        width: '24px',
        transform: 'translateY(-2px)',
        padding: 0
      },
      use: "transparent",
      children: /*#__PURE__*/_jsx(UIIcon, {
        color: EERIE,
        name: "info",
        size: "xxs"
      })
    })]
  });
};
const RecommendationsBasedOnProgress = () => {
  const history = useHistory();
  const [isResetModalOpen, setIsResetModalOpen] = useState(false);
  const {
    recommendations: response
  } = useRecommendations();
  const {
    recommendations
  } = response || {};
  const metadataList = useSelector(state => getRecommendationsMetadataList(state, recommendations));
  const hasMultipleStrategies = useMemo(() => {
    if (recommendations && recommendations.length > 0) {
      const strategy = recommendations[0].recommendationStrategy;
      return recommendations.some(x => x.recommendationStrategy !== strategy);
    }
    return false;
  }, [recommendations]);
  const hasMultipleUserInteractionIds = useMemo(() => {
    if (metadataList && metadataList.length > 0) {
      const entityId = metadataList[0].entityId;
      return !!(entityId && metadataList.some(x => x.entityId !== entityId));
    }
    return false;
  }, [metadataList]);
  if (!recommendations) return null;
  const showIndividualReasons = hasMultipleStrategies || hasMultipleUserInteractionIds;
  const onReasonLinkClick = (e, index) => {
    e.preventDefault();
    const {
      recommendationType,
      recommendationId,
      recommendationStrategy
    } = recommendations[index];
    const {
      entityId,
      entityType
    } = recommendations[index].recommendationMetadata;
    UsageTracker.track('interaction', {
      action: 'catalog-recommendation-reason-click',
      cardNumber: index + 1,
      lessonId: isLessonRecommendation(recommendationType) && recommendationId,
      trackId: recommendationType === 'TRACK' && recommendationId,
      recommendationStrategy,
      recommendedBecauseTrackId: entityType && entityType === 'TRACK' && entityId,
      recommendedBecauseLessonId: entityType && isLessonRecommendation(entityType) && entityId
    });
    if (entityType) history.push(`${isLessonRecommendation(entityType) ? 'lessons' : 'tracks'}/${entityId}`);
  };
  const getRecommendationReason = index => {
    if (!metadataList.length || !recommendations.length) return undefined;
    const meta = metadataList[index];
    return /*#__PURE__*/_jsx(FormattedReactMessage, {
      message: "learningCenter.tracks.subheaders.becauseYouInteracted",
      options: {
        contentNames: /*#__PURE__*/_jsx(LikeLink, {
          onClick: e => onReasonLinkClick(e, index),
          children: meta.contentName
        }, `reason_link_${meta.entityId}`)
      }
    });
  };
  const handleResetModalClose = () => {
    setIsResetModalOpen(false);
  };
  const handleInfoButtonClick = () => {
    setIsResetModalOpen(true);
  };
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsx(RecommendationsSection, {
      cardFooters: showIndividualReasons ? recommendations.map((value, key) => /*#__PURE__*/_jsx(Bold, {
        children: getRecommendationReason(key)
      }, `card_progress_${key}`)) : undefined,
      recommendations: recommendations,
      source: "recommendations-progress",
      subTitle: /*#__PURE__*/_jsx(SubTitle, {
        metadataList: metadataList,
        onInfoButtonClick: handleInfoButtonClick,
        showIndividualReasons: showIndividualReasons
      }),
      testId: "recommendations-based-on-progress"
    }), isResetModalOpen && /*#__PURE__*/_jsx(RecommendationsResetModal, {
      onClose: handleResetModalClose
    })]
  });
};
export default RecommendationsBasedOnProgress;